import React from 'react';
import { Building2, Target, Shield } from 'lucide-react';

const AboutSection: React.FC = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6 text-primary-900">
            Purpose-Driven Development
          </h2>
          <p className="text-gray-600 mb-6">
            At SL Rooms, we believe every empty building has the potential to become someone's home. 
            Our experienced team transforms commercial and mixed-use properties into affordable 1–2 bedroom
            apartments built to last—delivering value to investors and security to buyers.
          </p>
          <p className="text-gray-600 mb-12">
            We operate under both Planning Approval and Permitted Development Rights, ensuring speed,
            compliance, and high returns. Every unit is backed by a 10-year guarantee.
          </p>
        </div>

        <div className="mt-16">
          <div className="text-center mb-12">
            <h2 className="font-serif text-3xl md:text-4xl font-bold mb-4 text-primary-900">
              Smart Conversions. Real Impact.
            </h2>
            <p className="text-gray-600">
              We identify underused or outdated properties and reimagine them as sustainable, high-yield residential units.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gray-50 p-8 rounded-lg">
              <Building2 className="w-10 h-10 text-primary-700 mb-4" />
              <h3 className="text-xl font-serif font-semibold mb-3 text-gray-900">
                Affordable Living Spaces
              </h3>
              <p className="text-gray-600">
                Close to schools and transport links, making daily life convenient and accessible.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <Shield className="w-10 h-10 text-primary-700 mb-4" />
              <h3 className="text-xl font-serif font-semibold mb-3 text-gray-900">
                Energy-Efficient Homes
              </h3>
              <p className="text-gray-600">
                Designed for the future with sustainable features and modern amenities.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <Target className="w-10 h-10 text-primary-700 mb-4" />
              <h3 className="text-xl font-serif font-semibold mb-3 text-gray-900">
                Streamlined Planning
              </h3>
              <p className="text-gray-600">
                Efficient processes that maximise returns while ensuring full compliance.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <Building2 className="w-10 h-10 text-primary-700 mb-4" />
              <h3 className="text-xl font-serif font-semibold mb-3 text-gray-900">
                Investor Confidence
              </h3>
              <p className="text-gray-600">
                Reliable, profitable outcomes backed by our expertise and proven track record.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;